/* eslint-disable no-redeclare */
import ExcelJS from 'exceljs';
import moment from 'moment';
import Common from './common';
import { allMessages } from "../../_metronic/i18n/I18nProvider";
import store from "../store/store";
import SystemHelper from "./systemHelper";

export const importRegisterExcelMaxRowCount = 1000;
export const importSystemExcelMaxRowCount = 10000;
const unsupportedCustomFieldsForBatchOperations = ["MULTIPLE_CONTRACT_USERS", "SINGLE_CONTRACT_USER", "WEB_LINK", "MULTI_SELECT", "DATETIME"];

export const MIGRATION_MODE = {
    SYSTEM: "SYSTEM",
    REGISTER: "REGISTER"
}
export default class MigrationHelper {
    static supportedWorkflows = [
        1, 2, 4, 5, 6, 7, 8, 9, 10, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 27, 28, 29, 30, 31, 32, 33, 34,
        37, 38, 40, 42, 43, 46, 47, 48, 49, 50, 51, 52, 53, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68,
        69, 70, 71, 72, 73, 74, 75, 76, 77, 80, 81
      ];
    static getFormFieldsConfig = (baseFormFields, workflowItem, customFields, mode) => {
        const langStore = store.getState().i18n;

        const formFields = [];
        let unsupportedCustomFieldWarning = false;
        if (workflowItem?.assetFieldsEnabled) {
            formFields.push({
                caption: allMessages[langStore.lang]["GENERAL.FORMS.FIELD.ASSET_ID"],
                dataField: 'assetid',
                required: true,
                dataType: 'integer',
            })
        }
        if (mode === MIGRATION_MODE.SYSTEM) {
            formFields.push(
                {
                    caption: "Contract ID",
                    dataField: "contractid",
                    required: true,
                    dataType: 'integer',
                },
                {
                    caption: "External Reference ID",
                    dataField: "externalreferenceid",
                    required: false,
                    dataType: "string",
                },
                {
                    caption: "Communicated Date",
                    dataField: "communicateddate",
                    required: false,
                    dataType: "date",
                },
                {
                    caption: "Communicated By Account ID",
                    dataField: "communicatedbyaccountid",
                    required: false,
                    dataType: "integer",
                },

            );

        }
        const mainFormFields = baseFormFields.filter(f => f.isReplyField !== true);
        formFields.push(...mainFormFields);

        if (customFields && customFields.COMMUNICATION && customFields.COMMUNICATION.length > 0) {
            const { mappedCustomFields, unsupportedCustomFieldWarning: cfWarning } = this.mapCustomFieldsToExcelFormFields(customFields.COMMUNICATION);
            formFields.push(...mappedCustomFields);
            if (cfWarning) {
                unsupportedCustomFieldWarning = true;
            }
        }

        if (mode === MIGRATION_MODE.SYSTEM && workflowItem?.replyEnabled) {
            const replyFormFields = baseFormFields.filter(f => f.isReplyField === true);
            formFields.push(
                {
                    caption: "Replied Date",
                    dataField: "replieddate",
                    required: false,
                    dataType: "date",
                    isReplyField: true

                },
                {
                    caption: "Replied By Account ID",
                    dataField: "repliedbyaccountid",
                    required: false,
                    dataType: "integer",
                    isReplyField: true
                },
            );
            formFields.push(...replyFormFields);
            if (customFields && customFields.REPLY && customFields.REPLY.length > 0) {
                const { mappedCustomFields, unsupportedCustomFieldWarning: cfWarning } = this.mapCustomFieldsToExcelFormFields(customFields.REPLY);
                formFields.push(...mappedCustomFields);
                if (cfWarning) {
                    unsupportedCustomFieldWarning = true;
                }
            }
        }

        return { formFields, unsupportedCustomFieldWarning };
    }
    static mapCustomFieldsToExcelFormFields = (CFDefinitions) => {
        const mappedCustomFields = [];
        let unsupportedCustomFieldWarning = false;
        let activeCFFields = CFDefinitions.filter(cf => cf.isactive);
        if (activeCFFields.length > 0) {
            if (activeCFFields.some(cf => unsupportedCustomFieldsForBatchOperations.includes(cf.fieldtype))) {
                //THERE ARE UNSUPPORTED CUSTOM FIELDS
                //WARN USER
                unsupportedCustomFieldWarning = true;
                activeCFFields = activeCFFields.filter(cf => !unsupportedCustomFieldsForBatchOperations.includes(cf.fieldtype));
            }
            const mappedCFFields = activeCFFields.map(cf => {
                let dataType = "";
                let dataSource = null;
                let max = null;
                switch (cf.fieldtype) {
                    case "DATE":
                        dataType = "date";
                        break;
                    case "TEXT_SINGLE":
                        dataType = "string";
                        max = cf.maxlength;
                        break;
                    case "TEXT_MULTI":
                        dataType = "long-string";
                        max = cf.maxlength;
                        break;
                    case "SELECTBOX":
                        dataType = "list";
                        dataSource = (cf.selectoptions || "").split('|').sort((a, b) => a > b ? 1 : -1);
                        break;
                    case "NUMBER":
                        dataType = "decimal";
                        break;
                    case "INTEGER":
                        dataType = "integer";
                        break;
                    case "CURRENCY":
                        dataType = "money";
                        break;
                    case "CHECKBOX":
                        dataType = "bool";
                        break;
                    case "MULTIPLE_CONTRACT_USERS":
                    case "SINGLE_CONTRACT_USER":
                    case "WEB_LINK":
                    case "MULTI_SELECT":
                    case "DATETIME":
                        unsupportedCustomFieldWarning = true;
                        break;
                    default:
                        unsupportedCustomFieldWarning = true;
                        break;
                }

                return {
                    caption: cf.label,
                    dataField: "CF_" + cf.customfieldid,
                    required: cf.ismandatory,
                    dataType: dataType,
                    max: max,
                    options: {
                        dataSource: dataSource
                    }
                }
            });
            mappedCustomFields.push(...mappedCFFields);


        }
        return { mappedCustomFields, unsupportedCustomFieldWarning };;
    }
    static getColumnLetterFromIndex = (columnIndex) => {
        var temp, letter = '';
        while (columnIndex > 0) {
            temp = (columnIndex - 1) % 26;
            letter = String.fromCharCode(temp + 65) + letter;
            columnIndex = (columnIndex - temp - 1) / 26;
        }
        return letter;
    }
    static getExcelTemplate = (formFields, currencyCode, mode) => {
        if (!formFields || formFields.length === 0) {
            throw new Error("Form fields must be provided")
        }
        let maxRowCount = importRegisterExcelMaxRowCount;
        if (mode === MIGRATION_MODE.SYSTEM) {
            maxRowCount = importSystemExcelMaxRowCount;
        }
        const workbook = new ExcelJS.Workbook();
        workbook.creator = 'Built Intelligence';
        workbook.lastModifiedBy = 'Built Intelligence';
        workbook.created = new Date();
        workbook.modified = new Date();
        const worksheetWriter = workbook.addWorksheet('Import_Data', {
            views: [{ state: 'frozen', ySplit: 1 }],
            // properties: { outlineLevelCol: 1 }
        });

        worksheetWriter.columns = formFields
        .filter(field => field.visibleInTemplate !== false) // only add visible columns
        .map((field) => {
            let column = {
                header: field.caption,
                key: field.dataField,
                width: 30,
                style: {
                    // font: {
                    //     name: 'Comic Sans MS',
                    //     family: 4,
                    //     size: 16,
                    //     underline: true,
                    //     bold: true
                    // }
                }
                // type: ExcelJS.ValueType.Number
            };
            if (field.isReplyField) {
                column.style.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    // bgColor: { argb: 'FFF2D68A' },
                    fgColor: { argb: "FFF2D68A" }
                }
            }
            return column;
        });
        const lastColumnLetter = this.getColumnLetterFromIndex(formFields.length);
        worksheetWriter.autoFilter = {
            from: 'A1',
            to: lastColumnLetter + '1',
        }
        const headerRow = worksheetWriter.getRow(1);
        headerRow.eachCell((cell, colNumber) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: "808080" }
            }
            cell.font = {
                name: 'Aptos Narrow',
                color: { argb: "FFFFFF" },
                bold: true,
                size: 11,
            }
            cell.alignment = {
                vertical: 'middle',
                horizontal: 'center'
            };
            cell.border = {
                top: { style: 'double', color: { argb: '000000' } },
                left: { style: 'double', color: { argb: '000000' } },
                bottom: { style: 'double', color: { argb: '000000' } },
                right: { style: 'double', color: { argb: '000000' } }
            }
        }
        );


        formFields.forEach((field, index) => {
            const column = worksheetWriter.getColumn(index + 1);
            column.filterButton = false;
            const columnLetter = this.getColumnLetterFromIndex(index + 1);
            const validationRange = columnLetter + "2:" + columnLetter + maxRowCount;
            let currencySymbol = Common.GetCurrencySymbol(currencyCode);

            if (field.dataType === "list" || field.dataType === "multi") {
                column.filterButton = true;
                let fieldOptions = [];
                // let optionHasInvalidChars = false;
                if (!field.options) { throw new Error("List field[" + field.dataField + "] must have options") }
                if (field.options.dataSource && field.options.dataSource.length > 0) {
                    if (typeof field.options.dataSource[0] === "object") {
                        if (!field.options.valueExpr) { throw new Error("[" + field.dataField + "] valueExpr must be provided") }
                        if (!field.options.displayExpr) { throw new Error("[" + field.dataField + "] displayExpr must be provided") }
                        fieldOptions = field.options.dataSource.map(opt => opt[field.options.displayExpr]);
                    }
                    else if (typeof field.options.dataSource[0] === "string") {
                        fieldOptions = field.options.dataSource;
                    }
                    else {
                        throw new Error("[" + field.dataField + "] dataSource array unrecognized format")
                    }
                    let hiddenLookupWorkbook = this.createHiddenLookupSheet(workbook, field.caption, fieldOptions);
                    worksheetWriter.dataValidations.add(validationRange, {
                        type: 'list',
                        allowBlank: !field.required,
                        formulae: [`${hiddenLookupWorkbook.name}!$A$2:$A$${fieldOptions.length + 1}`],
                        showErrorMessage: true,
                        errorStyle: 'error',
                        error: 'Select from list',
                    });
                }
            }
            else if (field.dataType === "date") {
                column.numFmt = 'dd/mm/yyyy';
                worksheetWriter.dataValidations.add(columnLetter + "2:" + columnLetter + maxRowCount, {
                    type: 'date',
                    allowBlank: !field.required,
                    // operator: 'lessThan',
                    showErrorMessage: true,
                    // formulae: [new Date(2016,0,1)]
                });
                if (field.required) {
                    worksheetWriter.dataValidations.add(validationRange, {
                        type: 'textLength',
                        operator: 'greaterThan',
                        formulae: [0],
                        allowBlank: !field.required,
                        showErrorMessage: true,
                        errorStyle: 'error',
                        error: 'The date is required',
                    });
                }
            }
            else if (field.dataType === "money") {
                column.numFmt = currencySymbol + '0.00;[Red]-' + currencySymbol + '0.00';
                worksheetWriter.dataValidations.add(columnLetter + "2:" + columnLetter + maxRowCount, {
                    type: 'decimal',
                    allowBlank: !field.required,
                    showErrorMessage: true,
                    errorStyle: 'error',
                    error: 'The value must be decimals',
                });
            }
            else if (field.dataType === "integer") {
                column.numFmt = '0;[Red]-0';
                worksheetWriter.dataValidations.add(columnLetter + "2:" + columnLetter + maxRowCount, {
                    type: 'whole',
                    allowBlank: !field.required,
                    showErrorMessage: true,
                    errorStyle: 'error',
                    error: 'The value must be integer',
                });

                if (field.max) {
                    worksheetWriter.dataValidations.add(columnLetter + "2:" + columnLetter + maxRowCount, {
                        type: 'whole',
                        operator: 'lessThanOrEqual',
                        formulae: [field.max],
                        allowBlank: !field.required,
                        showErrorMessage: true,
                        errorTitle: 'Invalid Value',
                        errorStyle: 'error',
                        error: 'Maximum value is ' + field.max,
                    });
                }
                if (field.min) {
                    worksheetWriter.dataValidations.add(columnLetter + "2:" + columnLetter + maxRowCount, {
                        type: 'whole',
                        operator: 'greaterThanOrEqual',
                        formulae: [field.min],
                        allowBlank: !field.required,
                        showErrorMessage: true,
                        errorTitle: 'Invalid Value',
                        errorStyle: 'error',
                        error: 'Minimum value is ' + field.min,
                    });
                }
            }
            else if (field.dataType === "decimal") {
                column.numFmt = '0.00;[Red]-0.00';
                worksheetWriter.dataValidations.add(columnLetter + "2:" + columnLetter + maxRowCount, {
                    type: 'decimal',
                    allowBlank: !field.required,
                    showErrorMessage: true,
                    errorStyle: 'error',
                    error: 'The value must be decimals',
                });
            }
            else if (field.dataType === "string") {
                // column.numFmt = '@';
                worksheetWriter.dataValidations.add(columnLetter + "2:" + columnLetter + maxRowCount, {
                    type: 'textLength',
                    operator: 'lessThan',
                    formulae: [field.max ? field.max : 250],
                    allowBlank: !field.required,
                    showErrorMessage: true,
                    errorStyle: 'error',
                    error: 'The text must be less than 250 characters',
                });
                if (field.required || field.min) {
                    let min = field.min ? field.min : 0;
                    worksheetWriter.dataValidations.add(columnLetter + "2:" + columnLetter + maxRowCount, {
                        type: 'textLength',
                        operator: 'greaterThan',
                        formulae: [min],
                        allowBlank: !field.required,
                        showErrorMessage: true,
                        errorStyle: 'error',
                        error: 'The text must be minimum ' + min + ' characters',
                    });
                }
            }
            else if (field.dataType === "long-string") {
                // column.numFmt = '@';
                if (field.max) {
                    worksheetWriter.dataValidations.add(columnLetter + "2:" + columnLetter + maxRowCount, {
                        type: 'textLength',
                        operator: 'lessThan',
                        formulae: [field.max],
                        allowBlank: !field.required,
                        showErrorMessage: true,
                        errorStyle: 'error',
                        error: 'The text must be less than ' + field.max + ' characters',
                    });
                }
                if (field.required || field.min) {
                    let min = field.min ? field.min : 0;
                    worksheetWriter.dataValidations.add(columnLetter + "2:" + columnLetter + maxRowCount, {
                        type: 'textLength',
                        operator: 'greaterThan',
                        formulae: [min],
                        allowBlank: !field.required,
                        showErrorMessage: true,
                        errorStyle: 'error',
                        error: 'The text must be minimum ' + min + ' characters',
                    });
                }
            }
            else if (field.dataType === "time") {
                worksheetWriter.dataValidations.add(columnLetter + "2:" + columnLetter + maxRowCount, {
                    type: 'textLength',
                    operator: 'lessThanOrEqual',
                    formulae: [5],
                    allowBlank: !field.required,
                    showErrorMessage: true,
                    errorStyle: 'error',
                    error: 'Time format 00:00 and 23:59',
                });
                worksheetWriter.dataValidations.add(columnLetter + "2:" + columnLetter + maxRowCount, {
                    type: 'textLength',
                    operator: 'greaterThanOrEqual',
                    formulae: [5],
                    allowBlank: !field.required,
                    showErrorMessage: true,
                    errorStyle: 'error',
                    error: 'Time format 00:00 and 23:59',
                });
            }
            else {
                // worksheetWriter.dataValidations.add(columnLetter + "2:" + columnLetter + maxRowCount, {
                //     allowBlank: !field.required,
                //     showErrorMessage: true,
                //     errorStyle: 'error',
                //     error: 'The field is required',
                // });
            }
        });
        return workbook;
    }
    static createHiddenLookupSheet = (workbook, name, dataDource) => {
        let worksheetName = name.replace(/[^a-zA-Z0-9]/g, "_").toUpperCase()+"_OPTIONS";
        const hiddenWorksheet = workbook.addWorksheet(worksheetName, {
            // views: [{ state: 'frozen', ySplit: 1 }],
            // properties: { outlineLevelCol: 1 }

        });

        hiddenWorksheet.state = 'hidden';
        hiddenWorksheet.columns = [
            { header: name + ' Options', key: 'option', width: 30 },
        ];
        // hiddenWorksheet.columns[1]
        dataDource.forEach((item) => {
            hiddenWorksheet.addRow({ option: item });
        });

        return hiddenWorksheet;
    }
    static processExcelFile = (file, batchFormFields, dataCommonProperties, customFields, contractUsers, mode) => {
        return new Promise((resolve, reject) => {
            const wb = new ExcelJS.Workbook();
            const reader = new FileReader();
            let maxRowCount = importRegisterExcelMaxRowCount;
            if (mode === MIGRATION_MODE.SYSTEM) {
                maxRowCount = importSystemExcelMaxRowCount;
            }
            reader.readAsArrayBuffer(file);
            reader.onload = async () => {
                try {
                    const buffer = reader.result;
                    const workbook = await wb.xlsx.load(buffer);
                    const extractedData = [];

                    const isCustomFieldsEnabled =
                        (SystemHelper.getSettingValueBoolean(SystemHelper.SETTINGS.CUSTOM_FIELDS_ENABLED) &&
                            customFields &&
                            (
                                (customFields.COMMUNICATION && customFields.COMMUNICATION.length > 0) ||
                                (customFields.REPLY && customFields.REPLY.length > 0)
                            )
                        );

                    if (!workbook || !workbook.worksheets[0]) {
                        throw new Error("worksheet not found!")
                    }
                    if (workbook.worksheets[0].rowCount > (maxRowCount + 1)) {
                        throw new Error(`Can not process more than ${maxRowCount} rows!`)
                    }
                    if (workbook.worksheets[0].rowCount < 2) {
                        throw new Error("No records found in spreadsheet!")
                    }
                    workbook.worksheets[0].eachRow((row, rowIndex) => {
                        if (rowIndex > 1 && row.values && row.values.length > 0) {
                            let isAnyReplyFieldAssigned = false;
                            let indexOfFirstReply = batchFormFields.findIndex((x) => x.isReplyField === true);
                            if (indexOfFirstReply > -1) {
                                for (let i = indexOfFirstReply; i < batchFormFields.length; i++) {
                                    const columnNumber = i + 1;
                                    let value = row.values[columnNumber];
                                    if (value) {
                                        isAnyReplyFieldAssigned = true;
                                        break;
                                    }
                                }
                            }
                            this.validateExcelRow(row, rowIndex, batchFormFields, mode, isAnyReplyFieldAssigned)

                            const obj = { ...dataCommonProperties, rownum: rowIndex, replypropertiesassigned: isAnyReplyFieldAssigned };
                            
                            const batchFormFieldsWithDefaultValue = batchFormFields.find(x => 'defaultValue' in x);
                            if (batchFormFieldsWithDefaultValue) {
                                obj[batchFormFieldsWithDefaultValue.dataField] = batchFormFieldsWithDefaultValue.defaultValue;
                            }
                            
                            for (let i = 0; i < batchFormFields.length; i++) {
                                const columnNumber = i + 1;
                                const formField = batchFormFields[i];
                                if (formField.isReplyField && !isAnyReplyFieldAssigned) {
                                    //IF REPLY FIELD AND NOT ASSIGNED, THEN SKIP VALIDATION
                                    continue;
                                }
                                try {

                                    let value = row.values[columnNumber];
                                    if (value === undefined || value === null) {
                                        continue;
                                    }
                                    switch (formField.dataType) {
                                        case "long-string":
                                        case "string":
                                            //checks if it's an email
                                            if (value.hasOwnProperty('text') && value.hasOwnProperty('hyperlink')) {
                                                obj[formField.dataField] = value.text;
                                            } else {
                                                obj[formField.dataField] = value;
                                            }
                                            break;
                                        case "decimal":
                                        case "integer":
                                        case "money":
                                            obj[formField.dataField] = value;
                                            break;
                                        case "date":
                                            obj[formField.dataField] = this.getDateDisplayFromCell(value)
                                            break;
                                        case "list":
                                            if (formField.options.dataSource && formField.options.dataSource.length > 0) {
                                                if (typeof formField.options.dataSource[0] === "object") {
                                                    const selectedOption = formField.options.dataSource.find(opt => opt[formField.options.displayExpr] === value);
                                                    if (selectedOption) {
                                                        obj[formField.dataField] = selectedOption[formField.options.valueExpr];
                                                    }
                                                    else {
                                                        console.log("Selected option not found in data source", formField.options.dataSource, value, formField.options.displayExpr, formField.options.valueExpr);
                                                    }
                                                }
                                                else if (typeof formField.options.dataSource[0] === "string") {
                                                    obj[formField.dataField] = value;
                                                }
                                            }
                                            break;
                                        case "multi":
                                            if (formField.options.dataSource && formField.options.dataSource.length > 0) {

                                                const valuesArray = Array.isArray(value) ? value : [value];

                                                if (typeof formField.options.dataSource[0] === "object") {
                                                    const selectedValues = valuesArray.map(val => {
                                                        const matched = formField.options.dataSource.find(
                                                            opt => opt[formField.options.displayExpr] === val
                                                        );
                                                        return matched ? matched[formField.options.valueExpr] : null;
                                                    }).filter(v => v !== null);

                                                    obj[formField.dataField] = selectedValues;
                                                } else if (typeof formField.options.dataSource[0] === "string") {
                                                    obj[formField.dataField] = valuesArray;
                                                }
                                            }
                                            break;
                                        case "bool":
                                            if ((typeof value === "string" && (value === "1" || value.toUpperCase() === "TRUE" || value.toUpperCase() === "YES")) || value === 1 || value === true) {
                                                obj[formField.dataField] = true;
                                            } else {
                                                obj[formField.dataField] = false;
                                            }
                                            break;
                                        case "time":
                                            obj[formField.dataField] = this.getTimeDisplayFromCell(value);
                                            break;
                                        default:
                                            throw new Error(`Form field data type not defined: ${formField.dataField}`)
                                    }
                                }
                                catch (err) {
                                    console.log("MigrationHelper.processExcelFile Error assigning object columnNumber: " + columnNumber, err.toString(), formField)
                                }


                            }
                            if (isCustomFieldsEnabled) {
                                const cfs = [];
                                let customFieldsExist = false;

                                for (let field in obj) {
                                    if (field.startsWith("CF_")) {
                                        customFieldsExist = true;

                                        const cfid = Number(field.substring(3));

                                        //FIND CF DEFINITION
                                        let CF_DEF = customFields.COMMUNICATION?.find(cf => cf.customfieldid === cfid);
                                        if (!CF_DEF) {
                                            CF_DEF = customFields.REPLY?.find(cf => cf.customfieldid === cfid);
                                        }
                                        if (!CF_DEF) { throw new Error(`Custom Field Definition not found for ${field}`) }

                                        if (CF_DEF.fieldtype === 'SINGLE_CONTRACT_USER') {
                                            if (!contractUsers) { throw new Error('PropertyConversionsBeforeNoticeSaveRequest->ContractUsers must be provided!') }
                                            const { accountid: id, user: name } = contractUsers.find(u => u.accountid === obj[field]) || {};
                                            const cfvalue = { id, name }; //converts the result to this format { id: 1, name: 'John' }
                                            cfs.push({ customfieldid: cfid, value: JSON.stringify(cfvalue) });
                                        } else if (CF_DEF.fieldtype === 'MULTIPLE_CONTRACT_USERS') {
                                            if (!contractUsers) { throw new Error('PropertyConversionsBeforeNoticeSaveRequest->ContractUsers must be provided!') }
                                            const cfvalue = obj[field].map(i => {
                                                const { accountid: id, user: name } = contractUsers.find(u => u.accountid === i) || {};
                                                return { id, name };
                                            }); //prepares the result in this format [{ id: 1, name: 'John' }, { id: 2, name: 'Steve' }]
                                            cfs.push({ customfieldid: cfid, value: JSON.stringify(cfvalue) });
                                        }
                                        else {
                                            let cfvalue = obj[field];

                                            if (Array.isArray(obj[field])) {
                                                cfvalue = (obj[field]).join("|");
                                            }

                                            cfs.push({ customfieldid: cfid, value: cfvalue });
                                        }
                                        delete obj[field];
                                    }
                                }

                                //Appends custom fields to notification
                                if (customFieldsExist) {
                                    obj.customfieldvalues = cfs;
                                }
                            }
                            //Additional cross field validation checks
                            if (mode === MIGRATION_MODE.SYSTEM) {
                                if (obj.communicatedbyaccountid && !obj.communicateddate) {
                                    throw new Error(`Column Communicated Date is required when communicated by is assgned!`)
                                }
                                if (!obj.communicatedbyaccountid && obj.communicateddate) {
                                    throw new Error(`Column Communicated By Account ID is required when communicated date is assgned!`)
                                }

                                if (obj.repliedbyaccountid && !obj.replieddate) {
                                    throw new Error(`Column Replied Date is required when replied by is assgned!`)
                                }
                                if (!obj.repliedbyaccountid && obj.replieddate) {
                                    throw new Error(`Column Replied By Account ID is required when replied date is assgned!`)
                                }
                                if (isAnyReplyFieldAssigned) {
                                    if (!obj.communicatedbyaccountid || !obj.communicateddate) {
                                        throw new Error(`Column Communicated Date And Account is required when Reply info is provided!`)
                                    }
                                }
                            }
                            extractedData.push(obj);
                        }

                    });
                    resolve(extractedData);
                }
                catch (err) {
                    reject(err);
                }
            };
            reader.onerror = (error) => {
                reject(error);
            };
        })
    }

    static validateExcelRow = (row, rowIndex, batchFormFields, mode, isAnyReplyFieldAssigned) => {
        try {
            for (let i = 0; i < batchFormFields.length; i++) {
                const columnNumber = i + 1;
                const formField = batchFormFields[i];
                let value = row.values[columnNumber];
                if (formField.isReplyField && !isAnyReplyFieldAssigned) {
                    //IF REPLY FIELD AND NOT ASSIGNED, THEN SKIP VALIDATION
                    continue;
                }
                if (formField.required) {
                    if (value === undefined ||
                        value === null ||
                        value === ""
                    ) { throw new Error(`Column ${formField.caption} is required`) }
                }
                if (formField.dependOn) {
                    const { field: depFieldName, expectedValues } = formField.dependOn;

                    const depFieldIndex = batchFormFields.findIndex(f => f.dataField === depFieldName);
                    const depCaption = depFieldIndex !== -1 ? batchFormFields[depFieldIndex].caption : depFieldName;

                    const depCellValue = row.values[depFieldIndex + 1];

                    const isDepActive = expectedValues.includes(depCellValue);

                    if (isDepActive) {
                        if (value === undefined || value === null || value === "") {
                            throw new Error(`Column ${formField.caption} is required when ${depCaption} is ${depCellValue}`);
                        }
                    }
                }
                if (value) {
                    //IF THERE IS A VALUE, THEN VALIDATE THE DATA TYPE
                    switch (formField.dataType) {
                        case "long-string":
                        case "string":
                            if (!value.hasOwnProperty('text') && !value.hasOwnProperty('mailto') && (typeof value !== "string" && typeof value !== "number")) {
                                throw new Error(`Column ${formField.caption} must be a string`)
                            }
                            if (formField.min) {
                                if (value.length < formField.min) {
                                    throw new Error(`Column ${formField.caption} must be at least ${formField.min} characters`)
                                }
                            }
                            if (formField.max) {
                                if (value.length > formField.max) {
                                    throw new Error(`Column ${formField.caption} must be at most ${formField.max} characters`)
                                }
                            }
                            if (formField.pattern instanceof RegExp) {
                                if (!formField.pattern.test(value.text)) {
                                    throw new Error(`Column ${formField.caption} has an invalid format`);
                                }
                            }
                            break;
                        case "decimal":
                        case "integer":
                        case "money":
                            if (typeof value !== "number") {
                                throw new Error(`Column ${formField.caption} must be a number`)
                            }
                            if (formField.min) {
                                if (value < formField.min) {
                                    throw new Error(`Column ${formField.caption} must be at least ${formField.min}`)
                                }
                            }
                            if (formField.max) {
                                if (value > formField.max) {
                                    throw new Error(`Column ${formField.caption} must be at most ${formField.max}`)
                                }
                            }
                            if (formField.pattern instanceof RegExp) {
                                if (!formField.pattern.test(value)) {
                                    throw new Error(`Column ${formField.caption} has an invalid format`);
                                }
                            }
                            break;
                        case "date":
                            try {
                                this.getDateDisplayFromCell(value, formField.min, formField.max)
                            } catch (err) {
                                throw new Error(`Column ${formField.caption} is invalid date: ${err.toString()}`)
                            }

                            break;
                        case "list":
                            if (formField.options.dataSource && formField.options.dataSource.length > 0) {
                                let possibleValues = [];
                                if (typeof formField.options.dataSource[0] === "object") {
                                    possibleValues = formField.options.dataSource.map(opt => opt[formField.options.displayExpr]);

                                }
                                else if (typeof formField.options.dataSource[0] === "string") {
                                    possibleValues = formField.options.dataSource;
                                }
                                if (!possibleValues.includes(value)) {
                                    throw new Error(`Column ${formField.caption} is not a valid option`)
                                }
                            }
                            break;
                        case "multi":
                            if (formField.options.dataSource && formField.options.dataSource.length > 0) {
                                let possibleValues = [];

                                if (typeof formField.options.dataSource[0] === "object") {
                                    possibleValues = formField.options.dataSource.map(opt => opt[formField.options.displayExpr]);
                                } else if (typeof formField.options.dataSource[0] === "string") {
                                    possibleValues = formField.options.dataSource;
                                }

                                value = Array.isArray(value) ? value : [value];

                                const invalidValues = value.filter(v => !possibleValues.includes(v));
                                if (invalidValues.length > 0) {
                                    throw new Error(`Column ${formField.caption} has invalid options: ${invalidValues.join(", ")}`);
                                }
                            }
                            break;
                        case "bool":
                            break;
                        case "time":
                            try {
                                this.getTimeDisplayFromCell(value, formField.min, formField.max)
                            } catch (err) {
                                throw new Error(`Column ${formField.caption} is invalid time: ${err.toString()}`)
                            }
                            break;
                        default:
                            throw new Error(`Form field data type not defined: ${formField.dataField}`)
                    }
                }

            }
            // if (!partyTypeKeys.includes(row.values[1])) { throw new Error(`Invalid PartyType`) }
            // let actionType = row.values[2];
            // let wfid = 0;
            // if(actionType && actionType.startsWith("WF_")){
            //     actionType = actionType.substring(0,5);
            //     wfid = Number(actionType.substring(3));
            //     actionType = "WF_" + wfid;
            // }
            // if (!typeOptionKeys.includes(actionType)) { 
            //     if(actionType.startsWith("WF_")){
            //         throw new Error(`Unsupported workflow type:`+wfid) 
            //     }
            //     else{
            //         throw new Error(`Invalid Type`) 
            //     }

            // }
            // if (!row.values[3]) { throw new Error(`Subject is required`) }
            // if (!row.values[4]) { throw new Error(`Description is required`) }
            // if (!["YES", "NO"].includes(row.values[5])) { throw new Error(`Invalid Recurrent Option`) }
            // const isrecurrent = row.values[5] === "YES";
            // if (isrecurrent) {
            //     if (!row.values[7]) { throw new Error(`Start Date is required`) }
            //     ExcelHelper.getDateDisplayFromCell(row.values[7], moment().subtract(10,'years'), moment().add(10, 'years'))
            //     if (!row.values[8]) { throw new Error(`End Date is required`) }
            //     ExcelHelper.getDateDisplayFromCell(row.values[8], moment().subtract(10,'years'), moment().add(10, 'years'))
            //     // if (!frequencyOptionKeys.includes(row.values[9])) { throw new Error(`Invalid Frequency Option`) }

            //     const frequency = row.values[9];
            //     if (frequency === "WEEKLY") {
            //         // if (!weekdayOptionKeys.includes(row.values[10])) { throw new Error(`Invalid Weekday Option`) }
            //     }
            //     if (frequency === "MONTHLY") {
            //         if (!row.values[11]) { throw new Error(`Day of Month is required`) }
            //         const dayOfMonth = row.values[11];
            //         if (!(dayOfMonth >= 1 && dayOfMonth <= 28)) { throw new Error(`Day of Month out of range 1-28`) }
            //     }
            // }
            // else {
            //     if (!row.values[6]) { throw new Error(`Due Date is required`) }
            //     ExcelHelper.getDateDisplayFromCell(row.values[6], moment().subtract(10,'years'), moment().add(10, 'years'))
            // }
        } catch (err) {
            throw new Error(`Row:${rowIndex} ${err.toString()}!`)
        }

    }
    static getDateDisplayFromCell = (cellValue, minMoment, maxMoment) => {
        try {
            if (cellValue) {
                const dateVal = cellValue.result ? cellValue.result : cellValue;
                const momentObj = moment(dateVal);
                if (momentObj.isValid()) {
                    if (minMoment) {
                        if (momentObj.isBefore(minMoment.startOf('day'))) {
                            throw new Error(`Date can not be before ${minMoment.format('DD/MM/YYYY')}`)
                        }
                    }
                    if (maxMoment) {
                        if (momentObj.isAfter(maxMoment)) {
                            throw new Error(`Date can not be after ${maxMoment.format('DD/MM/YYYY')}`)
                        }
                    }
                    return momentObj.format('DD/MM/YYYY');
                }
                else {
                    throw new Error("Invalid Date")
                }
            }

        } catch (err) {
            throw err;
        }

    }
    static getTimeDisplayFromCell = (cellValue, minMoment, maxMoment) => {
        try {
            if (cellValue) {
                if (typeof cellValue === "string") {
                    if (cellValue.length !== 5) {
                        throw new Error("Invalid Time")
                    }
                    if (cellValue.charAt(2) !== ":") {
                        throw new Error("Invalid Time")
                    }
                    let valueParts = cellValue.split(":");
                    if (valueParts.length !== 2) {
                        throw new Error("Invalid Time")
                    }
                    if (valueParts[0].length !== 2 || valueParts[1].length !== 2) {
                        throw new Error("Invalid Time")
                    }
                    if (isNaN(valueParts[0]) || isNaN(valueParts[1])) {
                        throw new Error("Invalid Time")
                    }
                    if (Number(valueParts[0]) > 23 || Number(valueParts[1]) > 59) {
                        throw new Error("Invalid Time")
                    }
                    return cellValue;
                }
                else if (typeof cellValue === "object") {
                    const dateVal = cellValue.result ? cellValue.result : cellValue;
                    const momentObj = moment(dateVal);
                    if (momentObj.isValid()) {
                        return momentObj.format('HH:mm');
                    }
                    else {
                        throw new Error("Invalid Date")
                    }
                }

            }

        } catch (err) {
            throw err;
        }

    }
}